import { BaseControlledModal } from "../../../../../../common/components/base_controlled_modal";
import DefaultInput from "../../../../../../common/components/default_input";
import { BiometriaFacial } from "../../../../domain/models/biometria_facial";


import dayjs from "dayjs";
import { Funcionario } from "../../../../domain/models/funcionario";
type Props = {
  open: boolean;
  loading: boolean;
  imagemUrl: string | null;
  selectedBiometria: BiometriaFacial | null;
  selectedFuncionario: Funcionario | null;
  onClose: () => void;
};

export const VisualizacaoBiometriaModal = ({
  open,
  loading,
  imagemUrl,
  selectedBiometria,
  selectedFuncionario,
  onClose,
}: Props) => {
  const formatarData = (data?: Date | string | null) => {
    return data ? dayjs(data).format("DD/MM/YYYY") : "";
  };

  const formatarHora = (hora?: string | null) => {
    return hora ? hora.toString().substring(0, 8) : "";
  };

  return (
    <BaseControlledModal
      open={open}
      saving={false}
      loading={loading}
      title="Confirmação de recebimento"
      width="650px"
      onClose={onClose}
    >
      <div className="w-full flex flex-col gap-4 p-4 bg-gray-50 min-h-[300px] rounded-md mt-4">
        {loading ? (
          <span className="text-gray-500 text-center">
            Carregando imagem...
          </span>
        ) : imagemUrl ? (
          <>
            <div className="flex flex-col gap-4 w-full">
              
              <div className="flex flex-row gap-4 w-full">
                <div className="flex-1">
                  <DefaultInput
                    name="Funcionario"
                    label="Funcionário"
                    value={
                      selectedFuncionario?.nome?.toString() || ""
                    }
                    readOnly={true}
                  />
                </div>
                <div className="flex-1">
                  <DefaultInput
                    name="NomeCadastradoPor"
                    label="Verificado Por"
                    value={
                      selectedBiometria?.NomeCadastradoPor?.toString() || ""
                    }
                    readOnly={true}
                  />
                </div>
              </div>

              <div className="flex flex-row gap-4 w-full">
                <div className="flex-1">
                  <DefaultInput
                    name="Data"
                    label="Data"
                    value={formatarData(selectedBiometria?.Data)}
                    readOnly={true}
                  />
                </div>
                <div className="flex-1">
                  <DefaultInput
                    name="Hora"
                    label="Hora"
                    value={formatarHora(selectedBiometria?.Hora)}
                    readOnly={true}
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-center w-full mb-2">
              <img
                src={imagemUrl}
                alt="Biometria do Funcionário"
                className="max-w-full max-h-[40vh] object-contain rounded-md shadow-sm"
              />
            </div>
          </>
        ) : (
          <span className="text-gray-500 text-center flex-1 flex items-center justify-center h-full">
            Nenhuma imagem disponível para validação.
          </span>
        )}
      </div>
    </BaseControlledModal>
  );
};
